import { default as arrangementeneWaZc5zo8FMeta } from "/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/arrangementen.vue?macro=true";
import { default as donatie45KOpLO8yhMeta } from "/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/donatie.vue?macro=true";
import { default as gegevenssw28kzuFLlMeta } from "/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/gegevens.vue?macro=true";
import { default as indexBkBgGl6vtWMeta } from "/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/index.vue?macro=true";
import { default as overzichtqN5uYVYNLLMeta } from "/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/overzicht.vue?macro=true";
import { default as plan_45je_45bezoekTxrAqaEMHwMeta } from "/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/plan-je-bezoek.vue?macro=true";
import { default as ticketsISz3Mnx3HeMeta } from "/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/tickets.vue?macro=true";
export default [
  {
    name: arrangementeneWaZc5zo8FMeta?.name ?? "arrangementen",
    path: arrangementeneWaZc5zo8FMeta?.path ?? "/arrangementen",
    meta: arrangementeneWaZc5zo8FMeta || {},
    alias: arrangementeneWaZc5zo8FMeta?.alias || [],
    redirect: arrangementeneWaZc5zo8FMeta?.redirect || undefined,
    component: () => import("/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/arrangementen.vue").then(m => m.default || m)
  },
  {
    name: donatie45KOpLO8yhMeta?.name ?? "donatie",
    path: donatie45KOpLO8yhMeta?.path ?? "/donatie",
    meta: donatie45KOpLO8yhMeta || {},
    alias: donatie45KOpLO8yhMeta?.alias || [],
    redirect: donatie45KOpLO8yhMeta?.redirect || undefined,
    component: () => import("/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/donatie.vue").then(m => m.default || m)
  },
  {
    name: gegevenssw28kzuFLlMeta?.name ?? "gegevens",
    path: gegevenssw28kzuFLlMeta?.path ?? "/gegevens",
    meta: gegevenssw28kzuFLlMeta || {},
    alias: gegevenssw28kzuFLlMeta?.alias || [],
    redirect: gegevenssw28kzuFLlMeta?.redirect || undefined,
    component: () => import("/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/gegevens.vue").then(m => m.default || m)
  },
  {
    name: indexBkBgGl6vtWMeta?.name ?? "index",
    path: indexBkBgGl6vtWMeta?.path ?? "/",
    meta: indexBkBgGl6vtWMeta || {},
    alias: indexBkBgGl6vtWMeta?.alias || [],
    redirect: indexBkBgGl6vtWMeta?.redirect || undefined,
    component: () => import("/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/index.vue").then(m => m.default || m)
  },
  {
    name: overzichtqN5uYVYNLLMeta?.name ?? "overzicht",
    path: overzichtqN5uYVYNLLMeta?.path ?? "/overzicht",
    meta: overzichtqN5uYVYNLLMeta || {},
    alias: overzichtqN5uYVYNLLMeta?.alias || [],
    redirect: overzichtqN5uYVYNLLMeta?.redirect || undefined,
    component: () => import("/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/overzicht.vue").then(m => m.default || m)
  },
  {
    name: plan_45je_45bezoekTxrAqaEMHwMeta?.name ?? "plan-je-bezoek",
    path: plan_45je_45bezoekTxrAqaEMHwMeta?.path ?? "/plan-je-bezoek",
    meta: plan_45je_45bezoekTxrAqaEMHwMeta || {},
    alias: plan_45je_45bezoekTxrAqaEMHwMeta?.alias || [],
    redirect: plan_45je_45bezoekTxrAqaEMHwMeta?.redirect || undefined,
    component: () => import("/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/plan-je-bezoek.vue").then(m => m.default || m)
  },
  {
    name: ticketsISz3Mnx3HeMeta?.name ?? "tickets",
    path: ticketsISz3Mnx3HeMeta?.path ?? "/tickets",
    meta: ticketsISz3Mnx3HeMeta || {},
    alias: ticketsISz3Mnx3HeMeta?.alias || [],
    redirect: ticketsISz3Mnx3HeMeta?.redirect || undefined,
    component: () => import("/home/tickets-hzbmt/tickets.muzieum.nl/client/pages/tickets.vue").then(m => m.default || m)
  }
]